// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1CWCV","errorLogs":"EditorFooter_errorLogs__1JI2W"};